/**
 * 首页核心数据指标配置
 * Core metrics displayed on homepage
 */

export const coreMetrics = [
  {
    key: 'system_availability',
    value: '99.99',
    unit: '%',
    label: {
      zh: '系统可用性',
      en: 'System Availability',
      ja: 'システム可用性',
      ko: '시스템 가용성'
    },
    icon: 'fa-check-circle',
    description: {
      zh: '全年高可用保障',
      en: 'High availability guarantee',
      ja: '年間高可用性保証',
      ko: '연중 고가용성 보장'
    },
    color: 'text-green-600'
  },
  {
    key: 'service_regions',
    value: '11',
    unit: '',
    label: {
      zh: '服务地区',
      en: 'Service Regions',
      ja: 'サービス地域',
      ko: '서비스 지역'
    },
    icon: 'fa-globe-asia',
    description: {
      zh: '覆盖亚太主要市场',
      en: 'Covering major Asia-Pacific markets',
      ja: 'アジア太平洋主要市場をカバー',
      ko: '아시아태평양 주요 시장 커버'
    },
    color: 'text-blue-600'
  },
  {
    key: 'total_clients',
    value: '500',
    unit: '+',
    label: {
      zh: '服务客户',
      en: 'Clients Served',
      ja: 'サービス提供企業',
      ko: '고객사 수'
    },
    icon: 'fa-users',
    description: {
      zh: '累计服务企业客户',
      en: 'Total enterprise clients',
      ja: '累計サービス提供企業数',
      ko: '누적 엔터프라이즈 고객 수'
    },
    color: 'text-purple-600'
  },
  {
    key: 'certifications',
    value: '12',
    unit: '+',
    label: {
      zh: '技术认证',
      en: 'Certifications',
      ja: '技術認証',
      ko: '기술 인증'
    },
    icon: 'fa-award',
    description: {
      zh: '国际权威认证',
      en: 'International authoritative certifications',
      ja: '国際的な権威認証',
      ko: '국제 공인 인증'
    },
    color: 'text-yellow-600'
  }
];

export default coreMetrics;
